import React, { useMemo } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface ROCCurveChartProps {
  loading?: boolean;
}

const ROCCurveChart: React.FC<ROCCurveChartProps> = ({ loading }) => {
  if (loading) {
    return (
      <div className="h-48 flex items-center justify-center">
        <div className="animate-pulse bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 w-full h-full rounded-xl"></div>
      </div>
    );
  }

  const rocData = useMemo(() => 
    Array.from({ length: 21 }, (_, i) => {
      const fpr = i / 20;
      return {
        fpr: fpr,
        tpr_normal: Math.min(1, fpr + 0.3 + Math.random() * 0.2),
        tpr_degradation: Math.min(1, fpr + 0.25 + Math.random() * 0.15),
        tpr_sensor: Math.min(1, fpr + 0.2 + Math.random() * 0.1),
        tpr_grid: Math.min(1, fpr + 0.15 + Math.random() * 0.1)
      };
    }), []);

  return (
    <div className="w-full h-48 bg-gradient-to-br from-slate-50 to-white rounded-xl border border-slate-200 p-4">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={rocData}>
          <CartesianGrid strokeDasharray="2 2" stroke="#e2e8f0" opacity={0.3} />
          <XAxis 
            dataKey="fpr" 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
            label={{ value: 'False Positive Rate', position: 'insideBottom', offset: -5 }}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
            label={{ value: 'True Positive Rate', angle: -90, position: 'insideLeft' }}
          />
          <Tooltip />
          <Line type="monotone" dataKey="tpr_normal" stroke="#10b981" strokeWidth={2} dot={false} name="Normal" />
          <Line type="monotone" dataKey="tpr_degradation" stroke="#f59e0b" strokeWidth={2} dot={false} name="Degradation" />
          <Line type="monotone" dataKey="tpr_sensor" stroke="#ef4444" strokeWidth={2} dot={false} name="Sensor Fault" />
          <Line type="monotone" dataKey="tpr_grid" stroke="#8b5cf6" strokeWidth={2} dot={false} name="Grid Fault" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ROCCurveChart;